module.exports = __webpack_public_path__ + "static/img/icon4.fa128751.jpg";